import { createSlice } from "@reduxjs/toolkit";
import { fetchAdvtDetails, bookAdvtSlot } from "./advertisementThunks";

const initialState = {
  advt: null,
  slots: [],
  loading: false,
  bookingLoading: false,
  bookingResponse: null,
  error: null,
};

const advertisementSlice = createSlice({
  name: "advertisement",
  initialState,
  reducers: {
    clearBooking: (state) => {
      state.bookingResponse = null;
    },
    clearSlots: (state) => {
      state.advt = null;
      state.slots = [];
    },
  },
  extraReducers: (builder) => {
    builder

      /* -------- FETCH DETAILS -------- */
      .addCase(fetchAdvtDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdvtDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.advt = action.payload.advertisement; // ✅ FIX
        state.slots = action.payload.slots;
      })
      .addCase(fetchAdvtDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* -------- BOOK SLOT -------- */
      .addCase(bookAdvtSlot.pending, (state) => {
        state.bookingLoading = true;
        state.error = null;
      })
      .addCase(bookAdvtSlot.fulfilled, (state, action) => {
        state.bookingLoading = false;
        state.bookingResponse = action.payload;
      })
      .addCase(bookAdvtSlot.rejected, (state, action) => {
        state.bookingLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearBooking, clearSlots } = advertisementSlice.actions;
export default advertisementSlice.reducer;
